<nb-tabset (changeTab)="onChangeTab($event)">
  <nb-tab tabTitle="Consulta" tabIcon="upload-outline" responsive style="height: 80vh;">
    <p class="Titulo">Consulta - Origen</p>
      <button nbButton shape="round" size="small" class="buttontz float-left" style="margin-bottom: 10px;" (click)="consultarOrigenConsulta()">
        <nb-icon nbPrefix icon="refresh-outline"></nb-icon>
      </button>
    <app-spinner *ngIf="showSpinnerConsulta"></app-spinner>
    <div *ngIf="showGrillaConsulta">
      <angular-slickgrid gridId="gridOrigenConsulta"
      [columnDefinitions]="columnDefinitionsOrigenConsulta"
      [gridOptions]="gridOptionsOrigenConsulta" 
      [dataset]="datasetOrigenConsulta" 
      gridHeight="380"
      gridWidth="100%"
      (onAngularGridCreated)="angularGridReadyOrigenConsulta($event)">
    </angular-slickgrid>
  </div>
  <button nbButton size="tiny" style="float: right; margin-top: 50px;" class=" buttontz" [hidden]="!showGrillaConsulta" [disabled]="!showGrillaConsulta"
            (click)="exportToExcelOrigen()" ><nb-icon icon="save-outline"></nb-icon>Exportar</button>
  </nb-tab>
  <nb-tab *ngIf="usersRol.GESTIONAR_PARAMETROS_SISTEMA" tabTitle="Alta" tabIcon="upload-outline" responsive style="height: 80vh;">
    <div class="row">
      <div class="col-4 float-left">
            <p class="Titulo">Alta Origen</p>
            <p>
              <mat-form-field class="altaLabel">
                <mat-label>Ingresar Descripción</mat-label>
                <input matInput #message1 maxlength="80" [(ngModel)]="descripcionOrigen" name="descripcion">
                <mat-hint align="end">{{message1.value.length}} / 80</mat-hint>
              </mat-form-field>
            </p>
            <p>
              <mat-form-field class="altaLabel">
                <mat-label>Ingresar Descripción Breve</mat-label>
                <input matInput #message2 maxlength="40" [(ngModel)]="descripcionBreve" name="breve">
                <mat-hint align="end">{{message2.value.length}} / 40</mat-hint>
              </mat-form-field>
            </p>
            <p>
              <mat-form-field class="altaLabel">
                <mat-label>Ingresar Código Externo</mat-label>
                <input matInput #message3 maxlength="40" [(ngModel)]="codigoExterno" name="codigo">
                <mat-hint align="end">{{message3.value.length}} / 40</mat-hint>
              </mat-form-field>
            </p>
            <p>
              <app-spinner *ngIf="showSpinnerGuardar"></app-spinner>
              <button *ngIf="!showSpinnerGuardar" nbButton size="tiny" status="primary" class="buttontz" (click)="altaOrigen()">Guardar</button>
            </p>
          </div>
          <div>
            <button nbButton shape="round" size="small" class="buttontz float-right" (click)="consultarOrigen()">
              <nb-icon nbPrefix icon="refresh-outline"></nb-icon>
            </button>
          </div>
          <app-spinner class="col-6" *ngIf="showSpinner"></app-spinner>
          <div *ngIf="showGrilla" class="col-6">
            <angular-slickgrid gridId="gridOrigen"
            [columnDefinitions]="columnDefinitionsOrigen"
            [gridOptions]="gridOptionsOrigen" 
            [dataset]="datasetOrigen" 
            gridHeight="380"
            (onAngularGridCreated)="angularGridReadyOrigen($event)">
          </angular-slickgrid>
        </div>
      </div>
  </nb-tab>
  <nb-tab *ngIf="usersRol.GESTIONAR_PARAMETROS_SISTEMA" tabTitle="Modificación" tabIcon="edit-outline" responsive style="height: 75vh;">
    <p class="Titulo">Modificar Origen</p>
    <div class="row">
      <div class="col-4 float-left">
        <p-dropdown required class="limited-selector" id="inputTipo" placeholder="Seleccionar Origen"
          [style]="{'width':'100%','margin-bottom':'10px', 'margin-top':'10px'}" [options]="origen"
          [(ngModel)]="origenProcesado" (onChange)="obtenerDescripcionDropdown(origenProcesado)" [virtualScroll]="true"
          [itemSize]="31" [filter]="true"
          [ngClass]="{'form-control-danger': firstForm.invalid && (firstForm.dirty || firstForm.touched)}">
        </p-dropdown>
        <div>
          <p>
            <mat-form-field class="altaLabelModificar">
              <mat-label>Descripcion</mat-label>
              <input matInput #message4 maxlength="80" [(ngModel)]="descripcionOrigenEditar" name="descripcionOrigenEditar">
              <mat-hint align="end">{{message4.value.length}} / 80</mat-hint>
            </mat-form-field>
          </p>
          <p>
            <mat-form-field class="altaLabelModificar">
              <mat-label>Descripcion Breve</mat-label>
              <input matInput #message5 maxlength="40" [(ngModel)]="descripcionBreveEditar"
                name="descripcionBreveEditar">
              <mat-hint align="end">{{message5.value.length}} / 40</mat-hint>
            </mat-form-field>
          </p>
          <p>
            <mat-form-field class="altaLabelModificar">
              <mat-label>Código Externo</mat-label>
              <input matInput #message6 maxlength="40" [(ngModel)]="codigoExternoEditar" name="codigoExternoEditar">
              <mat-hint align="end">{{message6.value.length}} / 40</mat-hint>
            </mat-form-field>
          </p>
          <p>
            <nb-checkbox (checkedChange)="toggleEliminar($event)" [(ngModel)]="eliminarSeleccionado">Eliminar</nb-checkbox>
          </p>
          <p>
            <app-spinner *ngIf="showSpinnerModificar"></app-spinner>
            <button *ngIf="!showSpinnerModificar" nbButton size="tiny" status="primary" class="buttontz" (click)="modificarOrigen()" >Modificar</button>
          </p>
        </div>
      </div>
      <div class="col-6 float-right">
        <app-spinner class="col-6" *ngIf="showSpinnerModificarGrilla"></app-spinner>
          <div *ngIf="showGrillaModificar">
            <angular-slickgrid gridId="gridOrigenModificar"
            [columnDefinitions]="columnDefinitionsOrigenModificar"
            [gridOptions]="gridOptionsOrigenModificar" 
            [dataset]="datasetOrigenModificar" 
            gridHeight="380"
            (onAngularGridCreated)="angularGridReadyOrigenModificar($event)">
          </angular-slickgrid>
        </div>
      </div>
    </div>
  </nb-tab>
</nb-tabset>